export default "__VITE_ASSET__DNYAkLkE__"